export default class Files {
    constructor(endpoint) {
        // Directly return data object for Alpine.js x-data
        return this.data(endpoint);
    }

    data(endpoint) {
        return {
            files: [],
            SubPlan: null,
            newFile: null,
            Type: null,
            fileName: '',
            CustomProperties: null,
            clearFiles: false,
            loading: false,
            loadingFiles: false,
            Init(Type, SubPlan, CustomProperties = [], clearFiles = false) {
                this.SubPlan = SubPlan;
                this.Type = Type;
                this.CustomProperties = CustomProperties;
                this.clearFiles = Boolean(clearFiles);

                if (this.$el.parentNode.hasAttribute('data-quesiton-uid')) {
                    this.CustomProperties = JSON.stringify({'quesitonUid': this.$el.parentNode.getAttribute('data-quesiton-uid')});
                }

                this.GetFiles(this.Type, this.CustomProperties);
            },
            UploadFile(Event) {
                this.loading = true;
                const fileInput = Event.target;

                // Get the file from the input and store it in a separate variable to avoid any issues
                const file = fileInput.files[0];
                if (!file) return;  // Ensure there's a file to upload

                this.fileName = file.name;

                const bodyFormData = new FormData();
                bodyFormData.append('file', file);
                bodyFormData.append('subplan', this.SubPlan);

                const xhttp = new XMLHttpRequest();
                xhttp.open('post', '/woonmens/api/upload-files', true);

                // Use an arrow function here to preserve `this` context
                xhttp.onreadystatechange = () => {
                    if (xhttp.readyState == 4) {
                        this.loading = false;

                        if (xhttp.status == 200) {
                            const response = JSON.parse(xhttp.responseText);

                            if (response.new_url?.fileValidation) {
                                alert(response.new_url.fileValidation.file.contact_upload);
                            }

                            // clear the file input after the upload is complete
                            this.fileName = null;

                            // get files again
                            this.GetFiles(this.Type, this.CustomProperties);
                        }
                    }
                };
                xhttp.send(bodyFormData);
            },
            GetFiles(Type, CustomProperties) {
                this.loadingFiles = true;

                fetch('/woonmens/api/get-files/', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({'Type': Type, 'CustomProperties': CustomProperties}),
                })
                    .then(response => response.json().then(data => ({
                        error: !response.ok,
                        status: response.status,
                        errors: data.errors || null,
                        message: data.message,
                        options: data.options || [],
                        data: data || [],
                    })))
                    .then(response => {
                        if (response.data.Files) {
                            this.files = this.clearFiles ? response.data.Files : [...this.files, ...response.data.Files];
                        }
                    })
                    .catch((e) => console.error('Error fetching files:', e))
                    .finally(() => {
                        this.loadingFiles = false;
                    });
            },
            getSourceUrl(UniqueId) {
                const File = this.SearchForFile(UniqueId, this.files);
                return File ? `/woonmens/api/show-file/${encodeURIComponent(window.btoa(File.temporary_url))}` : null;
            },
            DownloadFile(UniqueId) {
                const File = this.SearchForFile(UniqueId, this.files);
                if (!File) return;

                const url = `/woonmens/api/download-file/?u=${this.Encode(File.temporary_url)}&t=${this.Encode(File.mime_type)}&n=${this.Encode(File.name)}`;
                window.open(url, '_blank');
            },
            SearchForFile(UniqueId, Arr) {
                return Arr?.find(file => file.unique_id === UniqueId) || null;
            },
            Encode(String) {
                return encodeURIComponent(window.btoa(String));
            },
        };
    }
}
